/** @format */

import image1 from '../images/memberships/Enmascarar grupo 7.png';
import image2 from '../images/memberships/Enmascarar grupo 6.png';
import first from '../images/memberships/first.png';
import second from '../images/memberships/second.png';


const memberships = [
  {
    id: 0,
    image: image2,
    icon: second,
    title: 'Inversión sin feedback',
    price: '19.9',
    price_before: '69',
    items: [
      {
        item: '34 Clases.',
        more: null,
      },
      {
        item: 'Aprende a tu ritmo.',
        more: null,
      },
      {
        item: 'Sin feedback en vivo.',
        more: null,
      },
      { item: 'Sin acceso a Discord.', more: null },
    ],
    urls: [
      {
        name: 'Pagar con PayPal',
        url: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=HMPSQDYX5MYLL',
      },
      {
        name: 'Pagar con Tarjeta',
        url: 'https://payco.link/1485071',
      },
    ],
  },
  {
    id: 1,
    image: image1,
    icon: first,
    title: 'Inversión con feedback',
    price: '24.99',
    price_before: '69',
    items: [
      {
        item: '34 Clases.',
        more: null,
      },
      {
        item: 'Un mes con feedback.',
        more: null,
      },
      {
        item: 'Acceso un año .',
        more: null,
      },
      { item: 'Discord privado.', more: null },
    ],
    urls: [
      {
        name: 'Pagar con PayPal',
        url: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=8TV78K9JEKXAY',
      },
      {
        name: 'Pagar con Tarjeta',
        url: 'https://payco.link/1481063',
      },
    ],
  },
  
];

export default memberships;
